import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { ConnectionService } from 'src/app/connection.service';

@Component({
  selector: 'app-unfreeze-history',
  templateUrl: './unfreeze-history.component.html',
  styleUrls: ['./unfreeze-history.component.css']
})
export class UnfreezeHistoryComponent implements OnInit {

  freezeList: any;
  unfreezeList: any;

  constructor(private conn: ConnectionService, private alert: ToastrService, private route: Router, private actRoute: ActivatedRoute, private modalService: BsModalService) {}
  ngOnInit() {
    this.getUnfreeze()
  }

  getUnfreeze() {
		this.conn.postUrl('vote/UnfreezeList', {}).subscribe((res: any) => {
			if (res.success == true) {
				this.unfreezeList = res.data
			}
		})
	}
  copyText(val: string) {
    let selBox = document.createElement('input');
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.alert.success('Copied to the clipboard');
  }


}
